import React from 'react';
import { useSelector } from 'react-redux';
import { Navbar } from 'react-bootstrap';
import { motion } from 'framer-motion';

const DynamicBrand = ({ className }) => {
  const { institute, asset_base_url } = useSelector((state) => state.auth);
  const getBrandConfig = () => {
    if (!institute) {
      return {
        brand_display_type: 'name',
        brand_name: 'Proton',
        institute_name: 'Proton',
        logo_url: null
      };
    }

    // Construct logo URL if logo path exists
    const logo_url = institute.logo && asset_base_url 
      ? `${asset_base_url}${institute.logo}` 
      : null;
      
    return {
      brand_display_type: institute.brand_display_type || 'name',
      brand_name: institute.brand_name || institute.institute_name || 'Proton',
      institute_name: institute.institute_name || 'Proton',
      logo_url
    };
  };

  const renderBrandContent = () => {
    const brandConfig = getBrandConfig();
    const { brand_display_type, brand_name, logo_url } = brandConfig;

    switch (brand_display_type) {
      case 'logo':
        return logo_url ? (
          <div className="brand-logo-container">
            <img 
              src={logo_url} 
              alt={brand_name}
              className="brand-logo"
              style={{
                height: '32px',
                width: 'auto',
                maxWidth: '120px',
                objectFit: 'contain'
              }}
              onError={(e) => {
                // Hide image and show fallback text
                e.target.style.display = 'none';
                const fallback = e.target.parentNode.querySelector('.logo-fallback');
                if (fallback) fallback.style.display = 'inline';
              }}
            />
            <span 
              className="logo-fallback brand-text" 
              style={{ display: 'none' }}
            >
              {brand_name}
            </span>
            <span 
              className="logo-fallback brand-dot" 
              style={{ display: 'none' }}
            ></span>
          </div>
        ) : (
          // Fallback to name if logo not available
          <>
            <span className="brand-text">{brand_name}</span>
            <span className="brand-dot"></span>
          </>
        );
      
      case 'both':
        return (
          <div className="d-flex align-items-center">
            {logo_url && (
              <img 
                src={logo_url} 
                alt={brand_name}
                className="brand-logo me-2"
                style={{
                  height: '28px',
                  width: 'auto',
                  maxWidth: '40px',
                  objectFit: 'contain'
                }}
              />
            )}
            <span className="brand-text">{brand_name}</span>
            <span className="brand-dot"></span>
          </div>
        );
      
      case 'name':
      default:
        return (
          <>
            <span className="brand-text">{brand_name}</span>
            <span className="brand-dot"></span>
          </>
        );
    }
  };

  return (
    <motion.div
      className={`logo ${className}`}
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
    >
      <Navbar.Brand>
        {renderBrandContent()}
      </Navbar.Brand>
    </motion.div>
  );
};

export default DynamicBrand;
